import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ApiError from '../../../../components/Errors/ApiError';
import { useUpcomingExpirations } from '../../myTeamQueries';
import { Table } from 'foundations-components/transitional/components/Table';
import { useState } from 'react';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { NavMarker } from 'react-rhumb';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UserAvatarLink from '../common/UserAvatarLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import CertificationLink from '../common/CertificationLink';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PAGE_SIZE = 5;
const NoResultsMessage = () => /*#__PURE__*/_jsx(View, {
  marginInline: "auto",
  maxInlineSize: "300px",
  children: /*#__PURE__*/_jsxs(ResultsMessage, {
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 180
    },
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.overview.certifications.noCertifications"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.overview.certifications.findContent"
    })]
  })
});
const UpcomingExpirations = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const {
    isDesktop,
    isMobile
  } = useMediaQuery();
  const {
    upcomingExpirations,
    upcomingExpirationsLoading,
    upcomingExpirationsError
  } = useUpcomingExpirations();
  if (upcomingExpirationsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (upcomingExpirationsError || !upcomingExpirations) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "UPCOMING_CERTIFICATION_EXPIRATIONS_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  const startIndex = (pageNumber - 1) * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const certificationsToDisplay = upcomingExpirations.slice(startIndex, endIndex);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "UPCOMING_CERTIFICATION_EXPIRATIONS_LOADED",
    children: certificationsToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "upcoming-expirations-table",
        truncated: isMobile,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "40%"
          }), /*#__PURE__*/_jsx("col", {
            width: "35%"
          }), /*#__PURE__*/_jsx("col", {
            width: "25%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.name"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.certification"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.teamMembers.upcomingExpirations.table.expiration"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: certificationsToDisplay.map((cert, index) => {
            const position = getPaginatedPosition(startIndex, index);
            return /*#__PURE__*/_jsxs("tr", {
              "data-test-id": "upcoming-expiration-row",
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(UserAvatarLink, {
                  displayAvatar: isDesktop,
                  position: position,
                  userEmail: cert.userEmail,
                  userId: cert.userId,
                  userName: cert.userName
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(CertificationLink, {
                  certificationId: cert.certificationId,
                  certificationName: cert.certificationName,
                  position: position,
                  showIcon: false
                })
              }), /*#__PURE__*/_jsx("td", {
                children: cert.expiresAt ? /*#__PURE__*/_jsx(FormattedDateTime, {
                  format: "ll",
                  value: cert.expiresAt
                }) : '--'
              })]
            }, `${cert.userId}-${cert.certificationId}-${index}`);
          })
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: ({
          target: {
            value
          }
        }) => setPageNumber(value),
        page: pageNumber,
        pageCount: Math.ceil(upcomingExpirations.length / PAGE_SIZE),
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsx(NoResultsMessage, {})
  });
};
export default UpcomingExpirations;